import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import React from 'react'
import {useFragment} from 'react-relay'
import useAtmosphere from '~/hooks/useAtmosphere'

import Menu from '../../../../components/Menu'
import MenuItem from '../../../../components/MenuItem'
import MenuItemLabel from '../../../../components/MenuItemLabel'














const StyledLabel = styled(MenuItemLabel)({
  padding: '4px 16px'
})

export const OrgTeamMemberMenu = (props) => {
  const {
    isViewerLead,
    isViewerOrgAdmin,
    teamMember: teamMemberRef,
    menuProps,
    togglePromote,
    toggleRemove
  } = props
  const teamMember = useFragment(
    graphql`
      fragment OrgTeamMemberMenu_teamMember on TeamMember {
        isSelf
        preferredName
        userId
        isLead
      }
    `,
    teamMemberRef
  )
  const atmosphere = useAtmosphere()
  const {preferredName, userId} = teamMember
  const {viewerId} = atmosphere
  const isSelf = userId === viewerId
  const isViewerTeamAdmin = isViewerLead || isViewerOrgAdmin

  return (
    React.createElement(Menu, { ariaLabel: 'Select your action', ...menuProps,}
      , isViewerTeamAdmin && (!isSelf || !isViewerLead) && (
        React.createElement(MenuItem, {
          label: React.createElement(StyledLabel, null, "Promote " , preferredName, " to Team Lead"   ),
          key: "promote",
          onClick: togglePromote,}
        )
      )
      , isViewerTeamAdmin && !isSelf && (
        React.createElement(MenuItem, {
          label: React.createElement(StyledLabel, null, "Remove " , preferredName, " from Team"  ),
          onClick: toggleRemove,}
        )
      )
    )
  )
}
